<template>
  <BaseLayout>
    <SubHeader></SubHeader>
    <div class="container">
      <!-- <div v-if="!$route.query.next_id && !$route.query.next_page" class="justify-content-center justify-content-md-between" style="display: flex; margin-bottom: 24px; flex-wrap: wrap;">
        <router-link to="/save-listing" class="btn btn-primary listing-link" style="margin-right: 8px; font-style: normal;">List a Horse for Sale</router-link>
        <router-link to="/save-service" class="btn btn-primary listing-link" style="margin-right: 8px; font-style: normal;">List a Service you provide</router-link>
      </div> -->
      <h1 class="text-center">Listing/Advertising Plans and Pricing</h1>
      <p class="text-center mt-3 mb-4">Questions? Email <a href="mailto:support@manestreetmarket.com">support@manestreetmarket.com</a></p>
      <div class="card-deck mb-3 text-center">
        <div class="card mb-4 mx-1 box-shadow">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">{{plans.basic.name}}</h4>
          </div>
          <div class="card-body">
            <div v-if="($route.query.next_page === 'save-listing' || $route.query.next_page === 'save-equipment') && $store.getters.can_list_trainer_listing">
              <h1 class="card-title pricing-card-title"><span style="text-decoration: line-through;">${{plans.basic.prices.monthly.price}}</span> $0</h1>
              <h1 class="card-title pricing-card-title">PER MONTH</h1>
              <p style="font-weight: bold;">Included with your {{$store.getters.active_trainer_package_name}} subscription</p>
            </div>
            <div v-else-if="($route.query.next_page === 'save-listing' || $route.query.next_page === 'save-equipment') && $store.state.is_trainer_package_subscriber && !$store.getters.can_list_trainer_listing">
              <h1 class="card-title pricing-card-title">${{plans.basic.prices.monthly.price}}</h1>
              <h1 class="card-title pricing-card-title">PER MONTH</h1>
              <p style="color: darkgray;"><i class="fa-solid fa-circle-info" style="margin-right: 4px;"></i>You have 15 active listings under the {{$store.getters.active_trainer_package_name}} which is the limit. Upgrade to the <router-link to="/trainer-package">{{plans.unlimited_package.name}}</router-link> to list more for free.</p>
            </div>
            <div v-else>
              <h1 class="card-title pricing-card-title">${{plans.basic.prices.monthly.price}}</h1>
              <h1 class="card-title pricing-card-title">PER MONTH</h1>
            </div>
            <p>
              The Basic Plan includes a map pin of the location of the horse, service, equipment, property or job. The listing is also added to the &quot;list&quot; option on the search function and the ad will also appear on the Mane Street Market app. <i>(Please download the Mane Street Market app or visit www.manestreetmarket.com to see examples of map pins and list options.)</i> Ads are also shared on MSM's FB and IG @manestreetmarket as a part of our customer service.
            </p>
          </div>
          <div class="card-footer">
            <router-link v-if="$route.query.next_id && ($route.query.next_page === 'save-listing' || $route.query.next_page === 'save-equipment') && $store.getters.can_list_trainer_listing" :to="{path: $route.query.next_page, query: {id: $route.query.next_id, payment_completed: 1}}" type="button" class="btn btn-block btn-primary">Select & Publish</router-link>
            <router-link v-else-if="$route.query.next_id && $route.query.next_page" :to="{name: 'subscribe', params: {id: plans.basic.code}, query: {next_page: $route.query.next_page, next_id: $route.query.next_id}}" type="button" class="btn btn-block btn-primary">Get Started</router-link>
            <router-link v-else to="/save-listing" type="button" class="btn btn-block btn-primary">Get Started</router-link>
          </div>
        </div>
        <div class="card mb-4 mx-1 box-shadow">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">{{plans.regional.name}}</h4>
          </div>
          <div class="card-body">
            <div>
              <h1 class="card-title pricing-card-title">${{plans.regional.prices.monthly.price}}</h1>
              <h1 class="card-title pricing-card-title">PER MONTH</h1>
            </div>
            <p>
              The Premium Plan includes the benefits of the Basic Plan (map pin/list on both website and app) plus a scrolling ad on the website which gives upgraded visibility. The Premium advertisement rotates on all search options on desktop. <i>(Please visit www.manestreetmarket.com and click on Horses for Sale or Service Providers to see website ads.)</i> Ads are also shared on MSM's FB and IG @manestreetmarket as a part of our customer service.
            </p>
          </div>
          <div class="card-footer">
            <router-link v-if="$route.query.next_id && $route.query.next_page" :to="{name: 'subscribe', params: {id: plans.regional.code}, query: {next_page: $route.query.next_page, next_id: $route.query.next_id}}" type="button" class="btn btn-block btn-primary">Get Started</router-link>
            <router-link v-else to="/save-listing" type="button" class="btn btn-block btn-primary">Get Started</router-link>
          </div>
        </div>
        <!-- <div class="card mb-4 box-shadow">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">{{plans.national.name}}</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">${{plans.national.prices.monthly.price}} <small class="text-muted">/ mo</small></h1>
            <p>
              App and Website Advertiser includes benefits of Website Advertiser and Basic Listing plus rotating banner advertisement on app. Ads on web and mobile apps include a hyperlink to advertiser's website. This option provides maximum exposure to the MSM audience. Please contact support@manestreetmarket.com for ad specs before choosing this option. <i>(Please download the Mane Street Market app to see current app banner ads scrolling on the bottom of the screen.)</i>
            </p>
          </div>
          <div class="card-footer">
            <router-link v-if="$route.query.next_id && $route.query.next_page" :to="{name: 'subscribe', params: {id: plans.national.code}, query: {next_page: $route.query.next_page, next_id: $route.query.next_id}}" type="button" class="btn btn-lg btn-block btn-primary">Get Started</router-link>
          </div>
        </div> -->
        <div class="card mb-4 mx-1 box-shadow" v-if="!$route.query.next_id && !$route.query.next_page">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">{{plans.trainer_package.name}}</h4>
          </div>
          <div class="card-body">
            <div>
              <h1 class="card-title pricing-card-title">${{plans.trainer_package.prices.monthly.price}}</h1>
              <h1 class="card-title pricing-card-title">PER MONTH</h1>
            </div>
            <p>
              The {{plans.trainer_package.name}} is ideal for trainers/sellers who consistently have 5 - 15 sales horses each month. This package gives you up to 15 Basic Listings (pin on map and included in list). Once you subscribe to the {{plans.trainer_package.name}} - you can add your horses as they are available and delete them when they sell or taken off the market. Listings/Ads also appear on the Mane Street Market app and shared on MSM's FB and IG @manestreetmarket as a part of our customer service.
            </p>
          </div>
          <div class="card-footer">
            <router-link v-if="!$store.state.is_trainer_package_subscriber && !$store.state.is_unlimited_package_subscriber" :to="{name: 'subscribe', params: {id: plans.trainer_package.code}, query: {next_page: 'trainer-package', next_id: 'trainer-package'}}" type="button" class="btn btn-block btn-primary">Get Started</router-link>
            <router-link v-else to="/trainer-package" type="button" class="btn btn-block btn-primary">Manage Subscription</router-link>
          </div>
        </div>
        <div class="card mb-4 mx-1 box-shadow" v-if="!$route.query.next_id && !$route.query.next_page">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">{{plans.unlimited_package.name}}</h4>
          </div>
          <div class="card-body">
            <div>
              <h1 class="card-title pricing-card-title">${{plans.unlimited_package.prices.monthly.price}}</h1>
              <h1 class="card-title pricing-card-title">PER MONTH</h1>
            </div>
            <p>
              The {{plans.unlimited_package.name}} includes unlimited Basic Listings (pin on map and included in list) for horses and equipment. This option is ideal for trainers/sellers who consistently have 15 or more sales horses each month and you also get unlimited equipment listings (tack, boots, etc). This is ideal for very large breeding or training/sales barns, live auctions, online auctions etc. Once you subscribe to the {{plans.unlimited_package.name}} - you can add your horses/equipment as they are available and delete them when they sell or taken off the market. Listings/Ads also appear on the Mane Street Market app and shared on MSM's FB and IG @manestreetmarket as a part of our customer service.
            </p>
          </div>
          <div class="card-footer">
            <router-link v-if="!$store.state.is_trainer_package_subscriber && !$store.state.is_unlimited_package_subscriber" :to="{name: 'subscribe', params: {id: plans.unlimited_package.code}, query: {next_page: 'trainer-package', next_id: 'unlimited-package'}}" type="button" class="btn btn-block btn-primary">Get Started</router-link>
            <router-link v-else to="/trainer-package" type="button" class="btn btn-block btn-primary">Manage Subscription</router-link>
          </div>
        </div>
      </div>
      <div v-if="!$route.query.next_id && !$route.query.next_page" class="text-center" style="margin: 0 auto; width: 400px; max-width: 100%; margin-bottom: 50px;">
        <router-link to="/save-listing" type="button" class="btn btn-block btn-outline" style="border: 1px solid #007bff; color: #007bff; font-size: 14px; margin-bottom: 8px !important; width: 100%;">List a Horse for Sale</router-link>
        <router-link to="/save-service" type="button" class="btn btn-block btn-outline" style="border: 1px solid #007bff; color: #007bff; font-size: 14px; width: 100%;">List a Service you provide</router-link>
      </div>
      <!--
      <div class="text-center">
        <h3 class="blue-top-border"><span></span>ADVERTISE ON MSM WEBSITE AND MOBILE APP</h3>
        <router-link to="/save-ads" class="btn btn-primary">Click here to Advertise</router-link>
      </div>
      -->
      <div class="section">
        <h2>FAQ</h2>
        <ACollapse accordion class="faq-collapsibles">
          <APanel header="I currently have multiple basic horse/equipment listings - what happens to them if I subscribe to the Trainer/Breeder Package or the Unlimited Package?" key="1">
            <p>Your current listings will merge into the Trainer/Breeder Package program for the next billing cycle.</p>
          </APanel>
          <APanel header="What are the benefits of choosing the Trainer/Breeder Package or the Unlimited Package?" key="2">
            <p>If you consistently have multiple horses and or equipment for sale - these package are perfect for you.</p>
            <p class="mt-3">The Trainer/Breeder package (${{ plans.trainer_package.prices.monthly.price }} per month) allows you to list up to 15 horses at the Basic option - incredible value if you are consistently listing 5-15 horses per month.</p>
            <p class="mt-3">The Unlimited package (${{ plans.unlimited_package.prices.monthly.price }} per month) is the best value of you list over 11 horses or more - we also offer unlimited equipment listings at this level so feel free to list your tack, boots, clothes and equipment you have for sale.</p>
          </APanel>
          <APanel header="What if I decide to cancel my Trainer/Breeder Package or Unlimited subscription?" key="3">
            <p>You will have the option to delete all of your listings at the time you delete your Trainer/Breeder Package or Unlimited subscriptions or you can choose to keep your selected listings and pay for each horse/equipment individually.</p>
          </APanel>
          <APanel header="I currently have a Basic or Premium listing - how can I upgrade that to a Trainer/Breeder or Unlimited Package?" key="4">
            <p>Please email <a href="mailto:support@manestreetmarket.com">support@manestreetmarket.com</a></p>
          </APanel>
        </ACollapse>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/layouts/Base.vue';
import SubHeader from '@/components/SubHeader.vue';
import plans from '@/constants/plans';
import { db } from '@/firebase';
import store from '@/store';
import ACollapse from 'ant-design-vue/lib/collapse';
import 'ant-design-vue/lib/collapse/style/index.css';

export default {
  components: {
    BaseLayout,
    SubHeader,
    ACollapse,
    APanel: ACollapse.Panel
  },
  data() {
    return {
      plans: plans
    }
  },
  async mounted() {
    document.title = 'Subscribe - Mane Street Market';
    window.scrollTo(0, 0);

    const user = this.$store.state.user;
    if (user) {
      Promise.all([
        db.collection('Horse').where('publisher', '==', user.uid).get(),
        db.collection('Services').where('publisher', '==', user.uid).get(),
        db.collection('Equipments').where('publisher', '==', user.uid).get()
      ]).then(snapshots => {
        const docs = snapshots.map(snapshot => snapshot.docs.map(doc => doc.data()).filter(d => (d.trainer_package_subscription_id != null || d.unlimited_package_subscription_id != null) && d.is_published)).flat();
        store.dispatch('setTrainerPackageListings', docs.length);
        console.log(docs.length);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .pricing-card-title {
    font-size: 28px;
  }
  
  .listing-link {
    margin: 0 !important;
    margin-top: 8px !important;
  }

  .card-header h4 {
    font-size: 1.2rem;
  }

  .faq-collapsibles {
    width: 100%;
    max-width: 800px;
  }

  .section {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 800px;
    max-width: 100%;
    margin: auto;
    gap: 16px;
  }
</style>